<script lang="ts">
import type { SupportedLanguageEnum } from '@app/utils/enums';
import { useLocaleStore } from '@app/stores/localeStore';
import { useI18n } from 'vue-i18n';

export default {
  async setup() {
    const { locale } = useI18n();
    const localeStore = useLocaleStore();

    const initializeLocale = async () => {
      const currentLangFromStorage = localStorage.getItem('lang') as SupportedLanguageEnum | null;

      if (currentLangFromStorage === localeStore.currentLang) return;

      if (currentLangFromStorage) {
        try {
          await localeStore.changeLang(currentLangFromStorage);
          locale.value = currentLangFromStorage;
        } catch (error) {
          console.error(error);
        }
      }
    };

    await initializeLocale();
  }
};
</script>

<template>
  <div>
    <slot></slot>
  </div>
</template>
